<template>
  <div class="index">
    <Back2Top v-if="showBack2Top" />
    <navHeaderV2 v-if="$route.meta.from !== 'zaxis'" />
    <main :class="[{'main-zaxis': $route.meta.from === 'zaxis'}]">
      <router-view />
    </main>
    <Footer  v-if="$route.meta.type === 'default'" />
  </div>
</template>

<script>
import Back2Top from '../components/back2Top.vue'
import navHeaderV2 from '../components/navHeaderV2.vue'
import Footer from '../components/Footer.vue'
import { mapState } from 'vuex'

export default {
  name: 'Index',
  components: { Back2Top, navHeaderV2, Footer },
  data () {
    return {}
  },
  computed: {
    ...mapState(['isLogin']),
    showBack2Top () {
      return !['/login', '/register', '/login-zaxis', '/register-zaxis'].includes(this.$route.path)
    }
  },
  methods: {},
  async mounted () {
    const queryToken = new URL(location.href).searchParams.get('token')
    const localStorageToken = localStorage.getItem('ZZT_SSO_TOKEN')
    const token = queryToken || localStorageToken
    // 前置条件：当前状态是没有登录的才进行登录尝试
    if (!this.isLogin && this.$route.name !== 'Login') {
      if (token) {
        this.$store.commit('setToken', token)
        await this.$store.dispatch('getUserInfo')
        // 重定向，去掉token参数
        if (new URL(location.href).searchParams.get('token')) {
          location.replace(location.href.split('?token')[0])
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.index {
  background-color: $bg-color;
  img {
    transition: width 0.5s;
  }
  main {
    margin-top: $header-height;
    overflow: hidden;
    min-height: calc(100vh - $header-height - Translate(330px));
  }
  .main-zaxis {
    margin-top: 0;
    overflow: hidden;
    min-height: 100vh;
  }
}
</style>
